import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
  id: "components-layout-demo-basic",
  class: "register-index"
};
const _hoisted_2 = {
  class: "login-div"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_layout_header = _resolveComponent("a-layout-header");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_select_option = _resolveComponent("a-select-option");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_radio = _resolveComponent("a-radio");
  const _component_a_radio_group = _resolveComponent("a-radio-group");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_input_password = _resolveComponent("a-input-password");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_card = _resolveComponent("a-card");
  const _component_a_layout_content = _resolveComponent("a-layout-content");
  const _component_a_layout_footer = _resolveComponent("a-layout-footer");
  const _component_a_layout = _resolveComponent("a-layout");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_layout, null, {
    default: _withCtx(() => [_createVNode(_component_a_layout_header), _createVNode(_component_a_layout_content, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_card, {
        title: _ctx.$t('login_title')
      }, {
        extra: _withCtx(() => [_createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = (...args) => $options.goToLogin && $options.goToLogin(...args))
        }, _toDisplayString(_ctx.$t('login')), 1)]),
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          activeKey: $data.form.user_type,
          "onUpdate:activeKey": _cache[1] || (_cache[1] = $event => $data.form.user_type = $event),
          tabPosition: "top",
          class: "text-left"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "20",
            tab: _ctx.$t('team')
          }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
            key: "10",
            tab: _ctx.$t('user'),
            "force-render": ""
          }, null, 8, ["tab"])]),
          _: 1
        }, 8, ["activeKey"]), _createVNode(_component_a_form, {
          model: $data.form,
          "label-col": $data.labelCol,
          "wrapper-col": $data.wrapperCol,
          rules: $data.rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: _ctx.$t('nationality'),
            name: "country"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              dropdownMatchSelectWidth: false,
              getPopupContainer: triggerNode => triggerNode.parentNode || _ctx.document.body,
              value: $data.form.country_id,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => $data.form.country_id = $event),
              "show-search": "",
              "option-filter-prop": "children",
              ref: "select",
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('tip_choose_country'),
              onChange: $options.handleChange
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.countryList, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  value: item.id,
                  key: index
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + "-" + _toDisplayString(item.cname), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["getPopupContainer", "value", "placeholder", "onChange"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('now_address'),
            name: "current_locate",
            class: "text-left"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: $data.form.current_locate,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => $data.form.current_locate = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: 1
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('domestic')), 1)]),
                _: 1
              }), _createVNode(_component_a_radio, {
                value: 2
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('abroad')), 1)]),
                _: 1
              })]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('account_type'),
            name: "type",
            class: "text-left"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_group, {
              value: $data.form.type,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => $data.form.type = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio, {
                value: 1
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('phone')), 1)]),
                _: 1
              }), _createVNode(_component_a_radio, {
                value: 2,
                disabled: $data.form.country_id == 44
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('email')), 1)]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }, 8, ["value"])]),
            _: 1
          }, 8, ["label"]), $data.form.user_type == '20' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: _ctx.$t('supplier_name'),
            name: "supplyName"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.name,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => $data.form.name = $event),
              placeholder: _ctx.$t('ph_supplier')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), $data.form.user_type == '10' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: _ctx.$t('name'),
            name: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.name,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => $data.form.name = $event),
              placeholder: _ctx.$t('ph_name')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), $data.form.type == 1 ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            label: _ctx.$t('login_phone'),
            name: "account"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.account,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => $data.form.account = $event),
              placeholder: _ctx.$t('ph_phone')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_a_form_item, {
            label: _ctx.$t('login_email'),
            name: "checkEmail"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.account,
              "onUpdate:value": _cache[8] || (_cache[8] = $event => $data.form.account = $event),
              placeholder: _ctx.$t('ph_email')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), [[_vShow, $data.form.type == 2]]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('password'),
            name: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: $data.form.password,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => $data.form.password = $event),
              placeholder: _ctx.$t('ph_pass_len'),
              autocomplete: "off"
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_a_form_item, {
            label: _ctx.$t('confirm_pass'),
            name: "repassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_password, {
              value: $data.form.repassword,
              "onUpdate:value": _cache[10] || (_cache[10] = $event => $data.form.repassword = $event),
              placeholder: _ctx.$t('ph_confirm_pass'),
              autocomplete: "off"
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"]), $data.form.user_type == '10' ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 3,
            label: _ctx.$t('tissue_id'),
            name: "team_number"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.team_number,
              "onUpdate:value": _cache[11] || (_cache[11] = $event => $data.form.team_number = $event),
              placeholder: _ctx.$t('ph_tissue_id')
            }, null, 8, ["value", "placeholder"])]),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_a_form_item, {
            label: _ctx.$t('ver_code'),
            name: "verification_code"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: $data.form.verification_code,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => $data.form.verification_code = $event),
              placeholder: _ctx.$t('ph_ver_code'),
              style: {
                "width": "180px"
              }
            }, null, 8, ["value", "placeholder"]), _withDirectives(_createElementVNode("input", {
              type: "button",
              class: "getNumber",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.codeMsg = $event),
              onClick: _cache[14] || (_cache[14] = (...args) => $options.getCode && $options.getCode(...args)),
              disabled: $data.codeDisabled
            }, null, 8, _hoisted_3), [[_vModelText, $data.codeMsg]])]),
            _: 1
          }, 8, ["label"]), [[_vShow, $data.form.type == 1]]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
            class: "register-btn",
            type: "primary",
            onClick: $options.save,
            size: $data.size
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('register')), 1)]),
            _: 1
          }, 8, ["onClick", "size"])])]),
          _: 1
        }, 8, ["model", "label-col", "wrapper-col", "rules"])]),
        _: 1
      }, 8, ["title"])])]),
      _: 1
    }), _createVNode(_component_a_layout_footer, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('copyright')), 1)]),
      _: 1
    })]),
    _: 1
  })]);
}